import { ModalSize } from '@/types/ModalSize';

export interface ITableDemand {
    offers: IOffer[];
    data: ITableDemandItem[];
    settings: ITableDemandSettings;
}

export type RatingScale = 'simtum' | 'pirsmr' | 'pstz' | 'tmcws' | '';

export type CritType = 'score' | 'info' | 'answer' | null;

export interface ITableDemandItem {
    critId: string;
    category: string;
    critName: string;
    critWeight: number | null;
    isInfoCrit: boolean;
    ratingScale: RatingScale;
    critType: CritType;
    answerType: string | null;
    answerReadonly: boolean;
    commentRequiredPredicate: string | null;
    offers: Record<string, IOfferCrit>;
}

export interface IOfferCrit {
    answer: string;
    answerSelect: string;
    description: string;
    score: number | null;
    rating: number | null;
    allowEdit: boolean;
    allowGroupEdit: boolean;
    applyToAllSupplierOffers?: boolean;
    applyToAllLotOffers?: boolean;
}

export interface IOffer {
    key: string;
    type: string;
    name: string;
    number: string;
    rank: string;
    result: string;
    acceptanceResult: number;
    acceptanceComment: string;
    approveToStageTwo: number | null;
    price: number | null;
    currencyCode: string;
    currencyText: string;
    summaryScore: number | null;
    actions: IOfferAction[];
}

export interface IOfferAction {
    key: string;
    displayName: string;
    title: string;
    modalSize: ModalSize;
    type: keyof typeof OfferActionTypes;
    visible: boolean;
}

export type OfferAnswerType = 'text' | 'select';

export interface IOfferAnswerSetting {
    key: string;
    type: OfferAnswerType;
    allowCustomAnswer: boolean;
    answers: IOfferAnswerItem[];
}

export interface IOfferAnswerItem {
    value: string;
    commentRequired: boolean;
}

export type TotalWinnerFactorType = 'summaryScore' | 'rank';

export interface ITableDemandSettings {
    emptyTextHeader: string;
    emptyText: string;
    offerCritDisabledHint: string;
    offerUnAcceptableHint: string;
    categorySortOrder: string[];
    priceVisible: boolean;
    editOfferCritButtonName: string | null;
    publicMode: boolean;
    hideSummary: boolean;
    lowCostPurchase: boolean;
    ratingScaleHints: Record<string, string> | null;
    customScaleCrits: string[] | null;
    offerAnswerSettings: IOfferAnswerSetting[] | null;
    totalWinnerFactor: TotalWinnerFactorType;
}

export enum OfferActionTypes {
    /// <summary>
    /// Открыть предложение
    /// </summary>
    OpenOffer,
    /// <summary>
    /// Скачать документацию
    /// </summary>
    DownloadAttachments,
    /// <summary>
    /// Оценить
    /// </summary>
    RateOffer,
    /// <summary>
    /// Технический анализ
    /// </summary>
    TechAnalysisOffer,
    /// <summary>
    /// Отображение кастомной формы документа
    /// </summary>
    CustomForm,
    /// <summary>
    /// Допустить ко второму этапу
    /// </summary>
    ApproveToStageTwo,
    /// <summary>
    /// Отправить на переоценку
    /// </summary>
    Revaluate,
    /// <summary>
    /// Оценить ПКО
    /// </summary>
    RateOfferPKO,
}
